export const defaultNodePosition = {
  pre_activity_job: { x: 400, y: 100 },
  form: { x: 410, y: 400 },
  pre_submission: { x: 400, y: 800 },
  state_change_logic: { x: 400, y: 1200 },
  jobs_trigger: { x: 400, y: 1600 }, //post activity
  activity_change_logic: { x: 400, y: 2000 } //next activity
};

export const jobTypes = [
  {
    key: "pre_activity_job",
    jobKey: "pre_activity",
    label: "Pre Activity Jobs",
    parentId: "1",
    jobType: "pre"
  },
  {
    key: "pre_submission",
    jobKey: "pre_submission",
    label: "Pre Submission Activity Jobs",
    parentId: "3",
    jobType: "pre_submission"
  },
  {
    key: "state_change_logic",
    jobKey: "state_change",
    label: "State Change Logic",
    parentId: "4",
    jobType: "state"
  },
  {
    key: "jobs_trigger",
    label: "Post Activity Jobs",
    jobKey: "post_activity",
    parentId: "5",
    jobType: "post"
  },
  {
    key: "activity_change_logic",
    jobKey: "post_activity",
    label: "Next Activity Jobs",
    parentId: "6",
    jobType: "activity"
  }
];

export const getPositionFromConfig = (positions, key) => {
  if (positions) {
    return positions[key];
  } else {
    return undefined;
  }
};

export const getDefaultParentEdges = (nodes, existingEdge) => {
  if (!nodes) return [];

  const markEnd = {
    type: "arrowclosed",
    width: 20,
    height: 20,
    color: "black"
  };

  const groupNodes = nodes
    .filter((node) => node.type === "groupNode" || node.type === "circleNode") //form is a circle node
    .sort((a, b) => Number(a.id) - Number(b.id)); //to generate edge in order

  const edges = [];

  groupNodes.forEach((node, index) => {
    const currNode = node.id;
    const nextNode = groupNodes[index + 1]?.id || null;

    const edgeId = `e${currNode}-${nextNode}`;
    const edgeAlreadyExist = existingEdge.find((edge) => edge.id === edgeId);

    if (edgeAlreadyExist) {
      edges.push(edgeAlreadyExist);
    } else {
      const edge = {
        source: currNode,
        target: nextNode,
        animated: true,
        type: "step",
        markerEnd: markEnd,
        nodeType: "groupNode",
        sourceHandle: `${currNode}-source`,
        targetHandle: `${nextNode}-target`,
        id: edgeId
      };

      if (nextNode) {
        edges.push(edge); // No edge without target
      }
    }
  });

  return edges;
};

export const getDefaultNodes = (
  positions,
  isAutoChildAlignMentRequired,
  onAddClick,
  updateParentPosition,
  addStateChangeLogic,
  nodesVisibilityList
) => {
  const defaultNodes = [
    {
      id: "1",
      position: getPositionFromConfig(positions, "pre") || defaultNodePosition.pre_activity_job,
      data: {
        label: "Pre Activity",
        position: "top-left",
        onAddClick,
        updateParentPosition,
        type: "pre",
        positionParent: getPositionFromConfig(positions, "pre") || defaultNodePosition.pre_activity_job,
        isAutoChildAlignMentRequired
      },
      type: "groupNode"
    },
    {
      id: "2",
      position: getPositionFromConfig(positions, "form") || defaultNodePosition.form,
      data: {
        label: "Form",
        type: "form",
        updateParentPosition,
        positionParent: getPositionFromConfig(positions, "form") || defaultNodePosition.form,
        isAutoChildAlignMentRequired
      },
      type: "circleNode"
    },
    {
      id: "3",
      position: getPositionFromConfig(positions, "pre_submission") || defaultNodePosition.pre_submission,
      data: {
        label: "Pre Submission Activity",
        position: "top-left",
        onAddClick,
        type: "pre_submission",
        updateParentPosition,
        positionParent: getPositionFromConfig(positions, "pre_submission") || defaultNodePosition.pre_submission,
        isAutoChildAlignMentRequired
      },
      type: "groupNode"
    },
    {
      id: "4",
      position: getPositionFromConfig(positions, "state") || defaultNodePosition.state_change_logic,
      data: {
        label: "State Change Logic",
        type: "state",
        position: "top-left",
        updateParentPosition,
        onAddClick: () => addStateChangeLogic("state_id", "state"),
        positionParent: getPositionFromConfig(positions, "state") || defaultNodePosition.state_change_logic,
        isAutoChildAlignMentRequired
      },
      type: "groupNode"
    },
    {
      id: "5",
      position: getPositionFromConfig(positions, "post") || defaultNodePosition.jobs_trigger,
      data: {
        label: "Post Activity",
        position: "top-left",
        onAddClick,
        type: "post",
        updateParentPosition,
        positionParent: getPositionFromConfig(positions, "post") || defaultNodePosition.jobs_trigger,
        isAutoChildAlignMentRequired
      },
      type: "groupNode"
    },
    {
      id: "6",
      position: getPositionFromConfig(positions, "activity") || defaultNodePosition.activity_change_logic,
      data: {
        label: "Next Activity",
        type: "activity",
        position: "top-left",
        updateParentPosition,
        onAddClick: () => addStateChangeLogic("activity_id", "activity"),
        positionParent: getPositionFromConfig(positions, "activity") || defaultNodePosition.activity_change_logic,
        isAutoChildAlignMentRequired
      },
      type: "groupNode"
    }
  ];

  //  Filter nodes based on nodesVisibilityList
  const filteredNodes = defaultNodes.filter((node) => node.data.type === "form" || nodesVisibilityList[node.data.type]);

  return filteredNodes;
};
